import { ModalFormBase } from "./modal_form_base.js"
import axios from 'axios';
export default class extends ModalFormBase{
  static get targets() {
    return ['contentModal', 'requireParentFormData'];
  }


  new(e){

    this.renderForm(e.detail[0].response);
    if (this.requireParentFormDataTargets.length > 0){
      this.renderParentData();
    }
    $(this.contentModalTarget).modal('show');

  }



  renderParentData(){
    let t = this;
     let parentForm = this.formController(document.querySelector('div[data-controller="form"'));
     var requiresRows = this.requireParentFormDataTarget; 
     parentForm.selectedRows().forEach(function(el){
          
          requiresRows.append(t.parsedData(el));
     })
  }

  parsedData(el){
   let tds = el.querySelectorAll('td[data-provides]');
   let template = this.requireParentFormDataTarget.querySelector('.templateRow')
   let identifier = template.querySelector('input[data-needed="id"]');

   let clonedTemplate = template.cloneNode();
   let  id = el.getAttribute('data-id');

   tds.forEach(function(td){
    var attr = td.getAttribute('data-provides').split('.'); 
    var refNode =template.querySelector('td[data-needed="' + attr.join('.') + '"]');
    var newTd = refNode.cloneNode();

    if (attr[1]){
      let templateInput = refNode.querySelector('input').cloneNode();
      templateInput.value = td.querySelector('input').value;
      templateInput.name = templateInput.name.replace('id', id);
      templateInput.removeAttribute('readonly');
      newTd.append(templateInput); 

    }
    else {
      newTd.innerHTML = td.innerHTML; 

    }
    clonedTemplate.append(newTd);
   })
   clonedTemplate.style.display = 'table-row';
   clonedTemplate.append(identifier.cloneNode());
   clonedTemplate.querySelector('input[data-needed="id"]').value = id;

   return clonedTemplate;
  } 
   

   formController(element) {

   
    return this.application.getControllerForElementAndIdentifier(element, "form");
    

  }

}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/po_modal_form_controller.js